import {
  Grid,
  makeStyles,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
} from '@material-ui/core';
import React, { useState } from 'react';
import DropFilesAttach from '../models/files/DropFilesAttach';
import PoTableQaApproval from '../supplierPOApprove/PoTableQaApproval';
import ShowFiles from '../updateGrRecord/ShowFiles';
import OtherInfo from './OtherInfo';
import CustomDatePickerMui from '../models/inputs/DateInput';

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 500,
    fontSize: '1.5rem',
    textAlign: 'left',
    paddingBottom: '0.3rem',
  },

  font: {
    fontWeight: 500,
    // padding: '0.5rem 0.5rem 0.5rem 0rem',
    textAlign: 'initial',
  },
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
  files: {
    boder: '1px solid #707070',
    backgroundColor: '#F7F7F7',
    textAlign: 'center',
    padding: '2rem',
  },
  grid: {
    paddingBottom: '2rem',
    paddingTop: '1rem',
    paddingRight: '1.5rem',
  },
  required: {
    color: 'red',
  },
}));

const QAInformation = (props) => {
  const classes = useStyles();
  const {
    onSave,
    poDetails,
    qaInfoData,
    setQaInfoData,
    // status,
    errors,
    handleChange,
    fileHandling,
    handlingDeleteFile,
    parentHandlingDeleteFile,
    OtherInfoTempNumber,
    handleTempNumber,
    handlingFiles,
    COAFiles,
  } = props;

  return (
    <>
      <PoTableQaApproval
        POLineRecordDetails={poDetails?.POLineRecordDetails}
        POBatchRecordDetails={poDetails?.GRDetails?.POBatchRecordDetails}
        receivedQuantityInfo={poDetails?.GRDetails?.receivedQuantityInfo}
        asnDetails={poDetails?.GRDetails?.asnDetails}
        qualityAssuranceInfo={poDetails?.GRDetails?.qualityAssuranceInfo}
      />
      <Grid container justifyContent='center'>
        <Grid item xs={12} sm={6} md={10}>
          <Grid container justifyContent='center'>
            {errors?.errorTitle && (
              <Grid
                container
                justifyContent='center'
                style={{ padding: '1rem 0' }}
              >
                <Grid item xs={12} sm={12} md={12}>
                  <Typography
                    variant='h6'
                    style={{
                      border: '1px solid #FF0000',
                      backgroundColor: '#FFF0F0',
                      opacity: '1',
                      textAlign: 'center',
                      padding: '0.8rem',
                      fontSize: '0.875rem',
                      whiteSpace: 'pre-wrap',
                    }}
                  >
                    {errors?.errorTitle}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Grid>

          <Grid container>
            <Grid item xs={12} sm={12} md={12} className={classes.grid}>
              <Typography variant='h4' className={classes.title}>
                {/* Quality Assurance Information */}
                Material Inspection Information
              </Typography>
              <span className={classes.borders}></span>
            </Grid>

            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Analytical Report (AR) Number{' '}
                <span className={classes.required}>*</span>
              </Typography>
              <TextField
                fullWidth
                size='small'
                variant='outlined'
                className={classes.textfieldWidth}
                placeholder='Enter Analytical Report Number'
                error={!!errors?.analyticalReportNumber}
                helperText={errors.analyticalReportNumber}
                value={qaInfoData?.analyticalReportNumber || ''}
                onChange={(e) =>
                  setQaInfoData((previousData) => ({
                    ...previousData,
                    analyticalReportNumber: e.target.value,
                  }))
                }
              />
              {/* <TextField
                fullWidth
                size='small'
                variant='outlined'
                className={classes.textfieldWidth}
                placeholder='Enter Analytical Report Number'
                error={!!errors?.cmoAnalyticalReportNumber}
                helperText={errors.cmoAnalyticalReportNumber}
                value={qaInfoData?.cmoAnalyticalReportNumber || ''}
                onChange={(e) =>
                  setQaInfoData((previousData) => ({
                    ...previousData,
                    cmoAnalyticalReportNumber: e.target.value,
                  }))
                }
              /> */}
            </Grid>
            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Unit of Measurement (UOM){' '}
                {/* <span className={classes.required}>*</span> */}
              </Typography>
              <TextField
                fullWidth
                size='small'
                variant='outlined'
                className={classes.textfieldWidth}
                // value={qaInfoData.unitOfMeasurementQA}
                value={poDetails?.POLineRecordDetails.unitOfMeasurementOrdered}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Quantity used for Sampling{' '}
                <span className={classes.required}>*</span>
              </Typography>
              <TextField
                fullWidth
                size='small'
                variant='outlined'
                className={classes.textfieldWidth}
                value={qaInfoData.samplingQuantityQA || 0}
                onChange={(e) =>
                  setQaInfoData((previousData) => ({
                    ...previousData,
                    samplingQuantityQA: e.target.value,
                  }))
                }
                error={!!errors?.qaQuantityFields}
                helperText={errors.qaQuantityFields}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Enter CMO Inspection Date{' '}
                <span className={classes.required}>*</span>
              </Typography>
              {/* <TextField
                fullWidth
                type='date'
                size='small'
                variant='outlined'
                className={classes.textfieldWidth}
                value={qaInfoData?.cmoQADate || ''}
                onChange={(e) =>
                  setQaInfoData((previousData) => ({
                    ...previousData,
                    cmoQADate: e.target.value,
                  }))
                }
                error={!!errors.cmoQADate}
                helperText={errors.cmoQADate}
              /> */}
              <CustomDatePickerMui
                name='cmoQADate'
                value={qaInfoData?.cmoQADate || null}
                error={!!errors.cmoQADate}
                onChange={(date) =>
                  setQaInfoData((previousData) => ({
                    ...previousData,
                    cmoQADate: date,
                  }))
                }
                helperText={errors.cmoQADate}
                FullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                CMO Sampling Material Number
              </Typography>
              <TextField
                fullWidth
                size='small'
                variant='outlined'
                className={classes.textfieldWidth}
                value={qaInfoData?.samplingMaterialNumberQA || ''}
                onChange={(e) =>
                  setQaInfoData((previousData) => ({
                    ...previousData,
                    samplingMaterialNumberQA: e.target.value,
                  }))
                }
              />
            </Grid>

            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Material Passed Quantity{' '}
                <span className={classes.required}>*</span>
              </Typography>
              <TextField
                fullWidth
                size='small'
                variant='outlined'
                className={classes.textfieldWidth}
                value={qaInfoData?.passedQtyQA || 0}
                onChange={(e) =>
                  setQaInfoData((previousData) => ({
                    ...previousData,
                    passedQtyQA: e.target.value,
                  }))
                }
                error={!!errors.qaQuantityFields}
                helperText={errors.qaQuantityFields}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Material Rejected Quantity{' '}
                <span className={classes.required}>*</span>
              </Typography>
              <TextField
                fullWidth
                size='small'
                variant='outlined'
                className={classes.textfieldWidth}
                value={qaInfoData?.rejectedQuantityQA || 0}
                onChange={(e) =>
                  setQaInfoData((previousData) => ({
                    ...previousData,
                    rejectedQuantityQA: e.target.value,
                  }))
                }
                error={!!errors.qaQuantityFields}
                helperText={errors.qaQuantityFields}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} className={classes.grid}>
              <DropFilesAttach
                title='Upload Certificates of Analysis (CoA/CoC)'
                handleUploadFiles={fileHandling}
                required={false}
              />
            </Grid>

            <Grid
              container
              className={classes.padding}
              style={{ paddingBottom: '1rem' }}
            >
              <Grid item xs={12} sm={6} md={6}>
                <Typography
                  variant='body2'
                  className={classes.font}
                  style={{ paddingBottom: '0.5rem' }}
                >
                  Uploaded Document List
                </Typography>

                <ShowFiles
                  files={COAFiles}
                  handlingDeleteFile={handlingDeleteFile}
                  name='COAFiles'
                  isUploadFile={true}
                  filesRequired={errors.coaFile}
                  // filesRequired={QAValidations.coaFile?.required}
                />
              </Grid>
            </Grid>
          </Grid>
          <hr />
          <Grid container>
            <Grid item xs={12} sm={12} md={12} className={classes.grid}>
              <Typography variant='h4' className={classes.title}>
                Other Information
              </Typography>
              <span className={classes.borders}></span>
            </Grid>
            <OtherInfo
              isAddRecord={true}
              qaInfoData={qaInfoData}
              handleChange={handleChange}
              handlingFiles={handlingFiles}
              //parent
              parentHandlingDeleteFile={parentHandlingDeleteFile}
              //appending file
              OtherInfoTempNumber={OtherInfoTempNumber}
              handleTempNumber={handleTempNumber}
            />
          </Grid>
          <Grid container item justifyContent='center' alignItems='center'>
            <Button variant='contained' color='primary' onClick={onSave}>
              Next
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default QAInformation;
